import didInsert from '@ember/render-modifiers/modifiers/did-insert';
import didUpdate from '@ember/render-modifiers/modifiers/did-update';
import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import BvModal from 'volta/components/bv-modal';
import TasksKit from 'volta/components/tasks-kit';
import classNames from 'volta/helpers/class-names';
import isTrue from 'volta/helpers/is-true';
import orElse from 'volta/helpers/or-else';
import TaskTypeBadge from '../tasks-kit/task-type-badge';

import type { TOC } from '@ember/component/template-only';
import type { TasksKitSignature } from 'volta/components/tasks-kit';

export interface TasksModalSignature {
  Args: TasksKitSignature['Args'] & {
    disabled?: boolean;
    inPage?: boolean;
    isLoading?: boolean;
    onClose: () => void;
    showDismiss?: boolean;
    translucentBackdrop?: boolean;
    authorizedUsers?: string[];
  };
  Element: HTMLElement;
}

const TasksModalComponent: TOC<TasksModalSignature> = <template>
  <TasksKit
    @onDestroy={{@onDestroy}}
    @onDeleteTask={{@onDeleteTask}}
    @onDraftTask={{@onDraftTask}}
    @onSaveTask={{@onSaveTask}}
    @tasks={{@tasks}}
    @isAutoResolvable={{@isAutoResolvable}}
    @taskType={{@taskType}}
    @groupingField={{@groupingField}}
    @entityId={{@entityId}}
    @scrollToDate={{@scrollToDate}}
    @entityResourceName={{@entityResourceName}}
    @isLoading={{@isLoading}}
    @disabled={{@disabled}}
    @authorizedUsers={{@authorizedUsers}}
    as |t|
  >
    <BvModal
      @title={{t.title}}
      @translucentBackdrop={{orElse @translucentBackdrop false}}
      @showDismiss={{orElse @showDismiss false}}
      @onClose={{optional @onClose}}
      @sheet={{true}}
      @belowAppHeader={{orElse @inPage false}}
      @onInsert={{t.scrollToTask}}
      class={{unless @inPage 'u-m-0 u-ml-auto'}}
      ...attributes
      as |modal|
    >
      <modal.Header>
        <:titleAction>
          <TaskTypeBadge @taskType={{@taskType}} class='u-ml-2' />
        </:titleAction>
        <:default>
          <t.ViewSelect class='u-mr-2' />
        </:default>
      </modal.Header>
      {{! template-lint-disable no-at-ember-render-modifiers }}
      <modal.Body
        class={{classNames (if (isTrue t.selectedTask) 'u-bg-surface-subdued') 'u-p-4'}}
        @scrollable={{true}}
        @sectioned={{false}}
        {{didInsert t.initScroll}}
        {{didUpdate t.scrollToTask}}
      >
        {{! @glint-ignore }}
        <t.List />
      </modal.Body>
      <modal.Footer
        @sticky={{true}}
        class='u-d-flex u-align-items-center u-justify-content-between u-p-5'
      >
        <t.SubmitBtn />
      </modal.Footer>
    </BvModal>
  </TasksKit>
</template>;

export default TasksModalComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Tasks::Modal': typeof TasksModalComponent;
    'tasks/modal': typeof TasksModalComponent;
  }
}
